/**
 * Faqs
 * ======================================
 * - jquery needed
 * - toggle class on parent item
 */
var $nav = $('.togglebox .togglebox-item-header')

var init = function() {
	bind()
}

var bind = function() {
	$nav.click(function(e){
		e.preventDefault();

		var $el = $(this);
		var $parent = $el.parent()
		var $content = $parent.find('.togglebox-item-main')

		$parent.toggleClass('is-open')
		$content.slideToggle()

	})
}

init()
